import {useMutation, useQueryClient} from 'react-query';
import {Contact, UserInfo} from '../types';
import {useMemo} from 'react';
import {
  NavigationProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {ChatParams, ChatStackParams} from '../types/nav';
import {sendChatMessage, writeItem} from '../api';

export const useRouteContact = (
  contact: Contact | undefined,
  isLoading: boolean,
  user: UserInfo,
  routeParams: ChatParams,
) => {
  const queryClient = useQueryClient();
  const navigation = useNavigation<NavigationProp<ChatStackParams>>();
  const route = useRoute();
  const {chatId, name, mnemonic} =
    routeParams || (route.params as ChatParams);
  const folderId = 'new_contact';
  const createContactMutation = useMutation(
    async () => {
      const ncontact = {
        id: chatId,
        isContact: true,
        folderId,
        name,
        mnemonic,
      };
      console.info('ncotanct', ncontact);
      await writeItem(ncontact);
    },
    {
      retry: true,
      onSuccess: async () => {
        try {
          await queryClient.refetchQueries('contact_' + chatId);
          navigation.navigate('Chat', {
            chatId,
            name,
            parentFolderId: folderId,
            mnemonic,
          });
          await sendChatMessage(
            chatId,
            user.name + ' has joined',
            mnemonic,
            {
              system: true,
            },
          );
          await queryClient.refetchQueries(
            'folderContent_' + folderId,
          );
        } catch (err) {
          console.error('onadd contact error', err);
        }
      },
    },
  );

  useMemo(() => {
    // console.info('useRouteContact Memo', isLoading, contact);
    if (!isLoading && !contact && !createContactMutation.isLoading) {
      createContactMutation.mutateAsync().then(async () => {
        console.info('after create contact');
      });
    }
  }, [isLoading, contact, createContactMutation]);
};
